import React, { useState } from "react";
import css from "./MainPage.module.scss";
import { Link, NavLink, Navigate, Outlet } from "react-router-dom";
import { home, home_active, profile, profile_active, services, services_active } from "./icons";
import SplashScreen from "../SplashScreen/SplashScreen";
import { useLocation } from 'react-router-dom';
import { useEffect } from "react";

const MainPage = () => {
    let location = useLocation();
    const refresh_token = localStorage.getItem("refresh_token");
    const [state, setNewState] = useState({ 
        isStarted: false,
        isVisible: false, 
        isBackdrop: false, 
        title: '', 
        content: <div></div>, 
        title_dashboard : '',
        background: '' });

    const setState = data => {
        setNewState(prevState => ({ ...prevState, ...data }));
    }

    const showBottomSheet = (title, content, background) => {
        if (background) setState({ isVisible: true, isBackdrop: true, title: title, content: content, background: background });
        setState({ isVisible: true, isBackdrop: true, title: title, content: content });
    }

    const hideBottomSheet = () => {
        setState({ isVisible: false });
        setTimeout(() => {
            setState({ isBackdrop: false });
        }, 250);
    }

    const onStarted = () => {
        setState({ isStarted: true });
    }

    const { isStarted, isVisible, isBackdrop, title, content, background, title_dashboard } = state;

    // if (!isStarted && window.isStarted !== true) {
    //     window.isStarted = true;
    //     return (<SplashScreen onStarted={onStarted} />);
    // }


    return (
        <div style={{ position: 'relative' }}>
            <div className= "main-content">
                
                <div>
                    <Outlet context={[showBottomSheet, hideBottomSheet]} />
                </div>
            </div>
            <div className={css.menu_bar}>
                <NavLink to="/home" className={css.menu_bar_item}>
                    {({ isActive }) => (
                        <>
                            <img src={isActive ? home_active : home} />
                            <span>Home</span>
                        </>
                    )}
                </NavLink>
                <NavLink to="/services" className={css.menu_bar_item}>
                    {({ isActive }) => (
                        <>
                            <img src={isActive ? services_active : services} />
                            <span>Services</span>
                        </>
                    )}
                </NavLink>
                <NavLink to="/profile" className={css.menu_bar_item}>
                    {({ isActive }) => (
                        <>
                            <img src={isActive ? profile_active : profile} />
                            <span>Profile</span>
                        </>
                    )}
                </NavLink>
            </div>
            {isBackdrop && (<div onClick={hideBottomSheet} style={{ width: '100%', height: '100vh', position: 'absolute', top: 0, left: 0, background: '#29292950', zIndex:9 }}></div>)}
            <div className={isVisible ? 'bottomsheet_show' : 'bottomsheet_hide'} style={{background: background}}>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: 20 }}>
                    <div style={{ flex: 1, fontSize: 20, fontWeight: 700, color: '#2C313A' }}>
                        {title}
                    </div>
                    <div onClick={hideBottomSheet} style={{ cursor: 'pointer' }}><span className="fi fi-rr-cross"></span></div>
                </div>
                <div>
                    {content}
                </div>

            </div>
        </div>
    )
}

export default MainPage